var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('badge',{attrs:{"loading":false,"type":_vm.statusType,"text":_vm.statusText}})}
var staticRenderFns = []

export { render, staticRenderFns }